import React from 'react';
// import "./index.css";
import Button from 'react-bootstrap/Button';

export type MoreInformationProps = {
  onClick: React.MouseEventHandler;
};

const MoreInformation = ({ onClick }: MoreInformationProps) =>
  onClick ? (
    <Button variant="success" onClick={onClick}>
      More Information
    </Button>
  ) : null;

export default MoreInformation;
